var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    rx: 8,
    fill: "#1F845A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90363 7.29461C5.87275 7.26282 5.8358 7.23755 5.79498 7.22029C5.75415 7.20303 5.71028 7.19414 5.66596 7.19414C5.62164 7.19414 5.57777 7.20303 5.53695 7.22029C5.49612 7.23755 5.45918 7.26282 5.4283 7.29461L4.96163 7.76194C4.93033 7.79284 4.90545 7.82962 4.88841 7.87016C4.87136 7.91071 4.86249 7.95422 4.86231 7.99819C4.86212 8.04217 4.87062 8.08576 4.88732 8.12644C4.90403 8.16713 4.9286 8.20411 4.95963 8.23528L7.4303 10.7066C7.49257 10.7688 7.57688 10.8039 7.66488 10.8043C7.75289 10.8046 7.83749 10.7703 7.9003 10.7086L13.0416 5.56728C13.073 5.53637 13.0978 5.49948 13.1146 5.45879C13.1314 5.41811 13.1399 5.37445 13.1396 5.33043C13.1392 5.28641 13.13 5.2429 13.1125 5.20251C13.0949 5.16211 13.0695 5.12565 13.0376 5.09528L12.571 4.62861C12.5397 4.59729 12.5027 4.57243 12.4618 4.55547C12.421 4.53851 12.3772 4.52979 12.333 4.52979C12.2887 4.52979 12.245 4.53851 12.2041 4.55547C12.1633 4.57243 12.1262 4.59729 12.095 4.62861L7.9043 8.81928C7.8411 8.88201 7.75567 8.91722 7.66663 8.91722C7.57758 8.91722 7.49215 8.88201 7.42896 8.81928L5.90363 7.29461Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    r: 6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.d53f39b196735ed0c7fa457f6606cf87.svg";
export { ForwardRef as ReactComponent };